import axios from 'axios';
import { ICrudGetAction, ICrudGetAllAction, ICrudPutAction, ICrudDeleteAction } from 'react-jhipster';

import { cleanEntity } from '../../../utils/entity-utils';
import { REQUEST, SUCCESS, FAILURE } from '../action-type.util';

import { IChartTemplateTimeSessionMatches, defaultValue } from '../../model/chart-template-time-session-matches.model';

export const ACTION_TYPES = {
  FETCH_CHARTTEMPLATETIMESESSIONMATCHES_LIST: 'chartTemplateTimeSessionMatches/FETCH_CHARTTEMPLATETIMESESSIONMATCHES_LIST',
  FETCH_CHARTTEMPLATETIMESESSIONMATCHES: 'chartTemplateTimeSessionMatches/FETCH_CHARTTEMPLATETIMESESSIONMATCHES',
  CREATE_CHARTTEMPLATETIMESESSIONMATCHES: 'chartTemplateTimeSessionMatches/CREATE_CHARTTEMPLATETIMESESSIONMATCHES',
  UPDATE_CHARTTEMPLATETIMESESSIONMATCHES: 'chartTemplateTimeSessionMatches/UPDATE_CHARTTEMPLATETIMESESSIONMATCHES',
  DELETE_CHARTTEMPLATETIMESESSIONMATCHES: 'chartTemplateTimeSessionMatches/DELETE_CHARTTEMPLATETIMESESSIONMATCHES',
  RESET: 'chartTemplateTimeSessionMatches/RESET',
};

const initialState = {
  loading: false,
  errorMessage: null,
  entities: [] as ReadonlyArray<IChartTemplateTimeSessionMatches>,
  entity: defaultValue,
  updating: false,
  totalItems: 0,
  updateSuccess: false,
};

export type ChartTemplateTimeSessionMatchesState = Readonly<typeof initialState>;

// Reducer

export default (state: ChartTemplateTimeSessionMatchesState = initialState, action): ChartTemplateTimeSessionMatchesState => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_CHARTTEMPLATETIMESESSIONMATCHES_LIST):
    case REQUEST(ACTION_TYPES.FETCH_CHARTTEMPLATETIMESESSIONMATCHES):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true,
      };
    case REQUEST(ACTION_TYPES.CREATE_CHARTTEMPLATETIMESESSIONMATCHES):
    case REQUEST(ACTION_TYPES.UPDATE_CHARTTEMPLATETIMESESSIONMATCHES):
    case REQUEST(ACTION_TYPES.DELETE_CHARTTEMPLATETIMESESSIONMATCHES):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        updating: true,
      };
    case FAILURE(ACTION_TYPES.FETCH_CHARTTEMPLATETIMESESSIONMATCHES_LIST):
    case FAILURE(ACTION_TYPES.FETCH_CHARTTEMPLATETIMESESSIONMATCHES):
    case FAILURE(ACTION_TYPES.CREATE_CHARTTEMPLATETIMESESSIONMATCHES):
    case FAILURE(ACTION_TYPES.UPDATE_CHARTTEMPLATETIMESESSIONMATCHES):
    case FAILURE(ACTION_TYPES.DELETE_CHARTTEMPLATETIMESESSIONMATCHES):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload,
      };
    case SUCCESS(ACTION_TYPES.FETCH_CHARTTEMPLATETIMESESSIONMATCHES_LIST):
      return {
        ...state,
        loading: false,
        entities: action.payload.data,
        totalItems: parseInt(action.payload.headers['x-total-count'], 10),
      };
    case SUCCESS(ACTION_TYPES.FETCH_CHARTTEMPLATETIMESESSIONMATCHES):
      return {
        ...state,
        loading: false,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.CREATE_CHARTTEMPLATETIMESESSIONMATCHES):
    case SUCCESS(ACTION_TYPES.UPDATE_CHARTTEMPLATETIMESESSIONMATCHES):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.DELETE_CHARTTEMPLATETIMESESSIONMATCHES):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: {},
      };
    case ACTION_TYPES.RESET:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

export const apiUrl = 'api/chart-template-time-session-matches';

// Actions

export const getEntities: ICrudGetAllAction<IChartTemplateTimeSessionMatches> = (page, size, sort) => {
  const requestUrl = `${apiUrl}${sort ? `?page=${page}&size=${size}&sort=${sort}` : ''}`;
  return {
    type: ACTION_TYPES.FETCH_CHARTTEMPLATETIMESESSIONMATCHES_LIST,
    payload: axios.get<IChartTemplateTimeSessionMatches>(`${requestUrl}${sort ? '&' : '?'}cacheBuster=${new Date().getTime()}`),
  };
};

export const getEntity: ICrudGetAction<IChartTemplateTimeSessionMatches> = id => {
  const requestUrl = `${apiUrl}/${id}`;
  return {
    type: ACTION_TYPES.FETCH_CHARTTEMPLATETIMESESSIONMATCHES,
    payload: axios.get<IChartTemplateTimeSessionMatches>(requestUrl),
  };
};

export const createEntity: ICrudPutAction<IChartTemplateTimeSessionMatches> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.CREATE_CHARTTEMPLATETIMESESSIONMATCHES,
    payload: axios.post(apiUrl, cleanEntity(entity)),
  });
  dispatch(getEntities());
  return result;
};

export const updateEntity: ICrudPutAction<IChartTemplateTimeSessionMatches> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_CHARTTEMPLATETIMESESSIONMATCHES,
    payload: axios.put(apiUrl, cleanEntity(entity)),
  });
  return result;
};

export const deleteEntity: ICrudDeleteAction<IChartTemplateTimeSessionMatches> = id => async dispatch => {
  const requestUrl = `${apiUrl}/${id}`;
  const result = await dispatch({
    type: ACTION_TYPES.DELETE_CHARTTEMPLATETIMESESSIONMATCHES,
    payload: axios.delete(requestUrl),
  });
  dispatch(getEntities());
  return result;
};

export const reset = () => ({
  type: ACTION_TYPES.RESET,
});
